var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetpage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H14M12 14V10M4 13C4.24486 11.056 5.19466 9.26941 6.66925 7.97914C8.14384 6.68887 10.0407 5.98464 12 6C13.294 6.00138 14.5684 6.31664 15.7139 6.91876C16.8593 7.52088 17.8416 8.39187 18.5764 9.45702C19.3113 10.5222 19.7768 11.7497 19.933 13.0343C20.0892 14.3189 19.9315 15.6222 19.4733 16.8324C19.0152 18.0426 18.2703 19.1236 17.3025 19.9827C16.3348 20.8418 15.1731 21.4533 13.9171 21.7648C12.6611 22.0763 11.3482 22.0784 10.0912 21.771C8.83422 21.4637 7.67054 20.8559 6.7 20L4 17.6",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17H4V22",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpage);
export default __webpack_public_path__ + "static/media/Resetpage.aa4c577bcbbf381b5c3a46baa93c52b7.svg";
export { ForwardRef as ReactComponent };